import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxField } from 'src/components/mui-overrides/Checkbox';

interface Props {
  disabled?: boolean;
}

export const ForumCheckbox: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <CheckboxField
      label={t('dashboard.assets.addedit.investment.securitytype.fields.forumActive')}
      fieldName="investmentDetails.forumActive"
      disabled={disabled}
    />
  );
};
